import { ICompanyForm, IPerson } from 'modules/common/CreatePersonModal/types';
import {
  TRegisterBusinessDataRequest,
  TRegisterPersonDataRequest,
} from 'modules/customer/context';
import { PixType } from 'modules/customer/context/CustomerProvider/customer.interfaces';
import { translatedWorkRelation } from 'modules/customer/helpers';
import { IBusinessPersonRelation } from 'modules/customer/services/api/interfaces';

// Parsers para unificar interfaces
export const convertBorrowerIntoCompany = (
  borrower?: TRegisterPersonDataRequest & TRegisterBusinessDataRequest,
  representatives?: IBusinessPersonRelation[],
): ICompanyForm => {
  const company: ICompanyForm = {
    address: {
      city: {
        label: borrower?.address?.city || '',
        value: borrower?.address?.city || '',
      },
      cityManually: borrower?.address?.city,
      state_code: {
        label: borrower?.address?.state_code || '',
        value: borrower?.address?.state_code || '',
      },
      country_code: borrower?.address?.country_code,
      district: borrower?.address?.district,
      postal_code: borrower?.address?.postal_code,
      street_name: borrower?.address?.street_name,
      street_number: borrower?.address?.street_number,
      extra_info: borrower?.address?.extra_info,
    },
    representatives: representatives || [],
    email_address: borrower?.email_address || '',
    foundation_date: borrower?.foundation_date || '',
    legal_name: borrower?.legal_name || '',
    phone: `(${borrower?.phone?.area_code}) ${borrower?.phone?.number}`,
    taxpayer_id: borrower?.taxpayer_id || '',
    external_bank_account: borrower?.external_bank_account,
    id: borrower?.id,
    incorporation_type: {
      label: borrower?.incorporation_type || '',
      value: borrower?.incorporation_type,
    },
    industry_classification: borrower?.industry_classification,
    tax_regime: {
      label: borrower?.tax_regime || '',
      value: borrower?.tax_regime || '',
    },
    pix: {
      key: borrower?.pix?.key || '',
      key_type: borrower?.pix?.key_type as PixType,
    },
    name: borrower?.name,
    monthly_revenue: borrower?.monthly_revenue?.toString(),
    role: borrower?.role,
    share_capital: borrower?.share_capital?.toString(),
  };

  return company;
};

export const convertBusinessPersonIntoPerson = (
  person: IBusinessPersonRelation,
): IPerson => {
  const parsedPerson: IPerson = {
    ...({} as IPerson),
    created_at: person.created_at,
    role: person.type,
    id: person.person.id,
    signer: {
      label: person.signer ? 'Sim' : 'Não',
      value: person.signer ? 'Sim' : 'Não',
    },
    workRelation: {
      label: translatedWorkRelation[person.type],
      value: person.type,
    },
    share: person.share,
    full_name: person.person.full_name,
    taxpayer_id: person.person.taxpayer_id,
  };

  return parsedPerson;
};
